import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

type Props = { size?: Unit };
export const GemIcon = ({
  size = 2,
  ...props
}: SVGProps<SVGSVGElement> & Props) => {
  return (
    <svg
      width="20"
      height="20"
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.14474 19.15L1.4595 13.1475L8.40873 18.8277L5.14474 19.15Z"
        fill="#00C900"
      />
      <path
        d="M1.4595 13.1475L5.56861 0.799988L7.13974 9.98506L1.4595 13.1475Z"
        fill="#B5F074"
      />
      <path
        d="M15.3781 4.04296L5.5686 0.799988L13.7465 7.52765L15.3781 4.04296Z"
        fill="#00B000"
      />
      <path
        d="M7.13973 9.98506L5.5686 0.799988L13.7465 7.52765L7.13973 9.98506Z"
        fill="#8CE456"
      />
      <path
        d="M8.40873 18.8277L7.13974 9.98505L1.4595 13.1475L8.40873 18.8277Z"
        fill="#8CE456"
      />
      <path
        d="M18.5405 11.2339L13.7465 7.52765L7.13974 9.98506L8.40873 18.8277L18.5405 11.2339Z"
        fill="#00B000"
      />
      <path
        d="M13.7466 7.52766L15.3781 4.04297L18.5405 11.2339L13.7466 7.52766Z"
        fill="#005500"
      />
      <path
        d="M13.7601 17.3386L8.40872 18.8277L18.5405 11.2339L13.7601 17.3386Z"
        fill="#00C900"
      />
    </svg>
  );
};
